import React from 'react';
import Modal from '../Modal';
import styles from '../manageUsers.module.scss';

export default function ResultOfSavingModal(props) {
  const {
    success, action, buttons, errorMessage, warningMessage,
  } = props;

  const verb = action === 'create' ? 'created' : 'updated';
  const successMessage = `The user was successfully ${verb}.`;

  let body;
  if (success && warningMessage) {
    body = (
      <div>
        {successMessage}
        <br />
        <span className={styles.warningText}>{warningMessage}</span>
      </div>
    );
  } else if (success) {
    body = (
      <div>
        {successMessage}
      </div>
    );
  } else {
    body = (
      <div className={styles.errorText}>
        {`There was an error while ${action === 'create' ? 'creating' : 'updating'} the user:`}
        <br />
        {errorMessage}
        <br />
        Please try again.
      </div>
    );
  }

  return (
    <Modal
      isOpen
      title="User Properties"
      buttons={buttons}
    >
      {body}
    </Modal>
  );
}
